import { Breadcrumbs, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { AppShell } from './app-shell/AppShell';



const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },

}))

export const UnderMaintenance: FunctionComponent<{ pageName: string }> = ({ pageName }) => {
    const classes = useStyles()
    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Grid item>
                    <Card className={classes.controlPaper}>
                        <CardContent>
                            <Grid container spacing={3} direction="column" justify="space-around"
                                alignItems="stretch">
                                <Grid item>
                                    <Breadcrumbs>
                                        <Link to="/" className={classes.link}>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                <HomeIcon className={classes.icon} />
                                                Home
                                            </Typography>
                                        </Link>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {pageName}
                                        </Typography>
                                    </Breadcrumbs>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                < Grid item>
                    <Card >
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Under Maintenance
                            </Typography>
                            <img src="/assets/img/under-maintenance.svg" alt="Under Maintenance" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </AppShell >
    )
}